import type {RentalResourceCalendarEvent} from '../types/RentalResourceCalendarEvent';
import type {CollisionLayout} from './detectEventCollisions';

/**
 * Gets the event collision layout for a specific event within a row
 *
 * @param event - The event to get layout for
 * @param collisionLayout - The collision layout containing all rows
 * @returns Object containing the row index and total rows needed
 *
 * @example
 * const event = { id: '1', start: new Date(), end: new Date() };
 * const layout = { rows: [{ events: [event], rowIndex: 0 }], maxRowsNeeded: 1 };
 *
 * const result = getEventCollisionLayout(event, layout);
 * // { rowIndex: 0, totalRows: 1 }
 */
export function getEventCollisionLayout(
  event: RentalResourceCalendarEvent,
  collisionLayout: CollisionLayout
) {
  const eventRow = collisionLayout.rows.find((row) => row.events.some((e) => e.id === event.id));

  if (!eventRow) {
    return {
      rowIndex: 0,
      totalRows: 1,
    };
  }

  return {
    rowIndex: eventRow.rowIndex,
    totalRows: collisionLayout.maxRowsNeeded,
  };
}
